window.angular.module('hippo').directive('mhNavContainer', function (featureToggle, HIPPO_CONSTS, partnerService) {
    'ngInject';
    return {
        restrict: 'E',
        replace: true,
        templateUrl: '/templates/directives/nav-container.html',
        controller: function ($scope, $location, userDataService, $timeout, $window) {
            'ngInject';

            $scope.additionalInfo = { producer: {} };
            $scope.isProduction = userDataService.isProduction();
            $scope.isNewDesign = featureToggle.showNewDesign();
            $scope.hippoTextLogo = $scope.isNewDesign ? 'hippo-icon-hippotext-green' : 'hippo-icon-hippotext-white';
            $scope.hippoIconLogo = $scope.isNewDesign ? 'hippo-icon-logo-green' : 'hippo-icon-logo-white';
            $scope.showPartnerFlowHeader = featureToggle.showPartnerFlowHeader();
            $scope.getHippoTextLogo = () => {
                if ($scope.isNewDesign) {
                    return 'hippo-icon-hippotext-green';
                } else {
                    return 'hippo-icon-hippotext-white';
                }
            };

            $scope.hippoTextLogo = $scope.getHippoTextLogo();
            $scope.showSVGPlus = false;
            $scope.showAgentContactInfo = false;
            $scope.callSupport = () => {
                window.location.href = `tel:${featureToggle.getContactDetail('phone', 'HIPPO_SALES')}`;
            };

            const setPartnerLogo = () => {
                const partnerPage = partnerService.partnerPage;
                $scope.partnerName = partnerService.partnerName;
                $scope.hideContactSupport = partnerService.hideContactSupport;
                $scope.showNavPartnerLogo =
                    !featureToggle.isStaticPage($window.location.pathname) && featureToggle.hasCoBrandedFlowLogos();
                $scope.partnerLogoFix = partnerPage['image_position_correction'];
                $scope.logoTopPosition = $scope.partnerLogoFix ? partnerPage['image_position_pixel'] : 0;
                $scope.partnerImageUrl = (color) => partnerPage[`image_${color}`];
            };

            $scope.phoneNumberType = $location.search()['agreementId'] ? 'support' : 'sales';
            if (featureToggle.isBuilderPrequoteFlow()) {
                setPartnerLogo();
                $scope.showPartnerBar = true;
                $scope.showAgentContactInfo = true;
                $scope.callAgent = () => {
                    window.location.href = `tel:${featureToggle.getContactDetail('phone', 'HIPPO_SALES')}`;
                };
                const { $ } = window;
                const mobileBreakpoint = 767;
                const isMobile = () => {
                    return $(document.body).width() <= mobileBreakpoint;
                };
                if (isMobile()) {
                    $scope.callSupport = () => {
                        $scope.isShowAgentOverlay = true;
                    };
                }
                $scope.closeAgentOverlay = () => {
                    $scope.isShowAgentOverlay = false;
                };
                $scope.disableReturnToLanding = true;
            }

            if (featureToggle.isPartnerFlow() && partnerService.hasPartnerPage) {
                setPartnerLogo();
                $scope.showSVGPlus = true;
            }

            if ($scope.showPartnerFlowHeader) {
                $scope.showSimpliSafePlus = featureToggle.isSmartHomePartnerPage();
                $scope.showPartnerBar = !$scope.showSimpliSafePlus && featureToggle.isGeneralPartnerPage();
                $scope.showNavPartnerLogo = true;
                $scope.showSVGPlus = false;
                const partnerPage = partnerService.partnerPage;
                $scope.partnerName = partnerPage.partner_name;
                $scope.partnerLogoSize = partnerPage.image_size;
                $scope.partnerLogoSizeMobile = partnerPage.image_size_mobile;
                $scope.partnerImageUrl = () => partnerPage[`image_dark`];
            }

            $scope.landingUrl = '/' + $window.location.search;
            $scope.aboutUrl = '/about' + $window.location.search;
            $scope.supportUrl = '/contact-us' + $window.location.search;
            $scope.claimUrl = '/claim' + $window.location.search;
            $scope.faqUrl = '/faq' + $window.location.search;

            $scope.contactIconGreen = $scope.isNewDesign
                ? '/img/new-design/hippo-icon-phone-green.svg'
                : '/img/phone_support.svg';
            $scope.contactIconWhite = $scope.isNewDesign
                ? '/img/new-design/hippo-icon-phone-white.svg'
                : '/img/phone_support_white.svg';

            $scope.isCallUsEnabled =
                featureToggle.showCallUs() && !featureToggle.isBuilderPrequoteFlow() && !featureToggle.isPartnerFlow();
            $scope.contactNumber = featureToggle.getContactDetail('phone', 'HIPPO_SALES');
            $scope.hideHippoLogo =
                ($scope.isNewDesign && $scope.isCallUsEnabled) || featureToggle.isHomePointFinancialFlow();
            $scope.showMobileChatTransition = false;
            $scope.showDesktopTransition = false;

            $scope.$on('navbar:showChatTransition', (event, msg) => {
                if (msg.type === 'mobile') {
                    $scope.showMobileChatTransition = true;
                } else if (msg.type === 'desktop') {
                    $scope.showDesktopTransition = true;
                }
            });
            $scope.$on('navbar:hideChatTransition', () => {
                $scope.showMobileChatTransition = false;
                $scope.showDesktopTransition = false;
            });
            $scope.closeMobileMsg = () => {
                $scope.showMobileChatTransition = false;
            };

            $scope.returnToLanding = () => {
                if ($scope.backToLanding) {
                    $scope.handleDeepEvent({ eventType: 'backToLanding' });
                    $timeout(() => {
                        // delay so landing page code can load and animate
                        $scope.$broadcast('landing:closeMobileAddressInput');
                    }, 100);
                } else {
                    window.location.href = $scope.landingUrl;
                }
                $scope.holdScrollWhileRendering(2500);
            };

            if (featureToggle.isXfinityFlow()) {
                $scope.landingUrl = '/xfinity';
                $scope.aboutUrl = '/xfinity-about';
                $scope.supportUrl = '/xfinity-support';
                $scope.claimUrl = '/xfinity-claim';
                $scope.faqUrl = '/xfinity-faq';
            }

            if (featureToggle.showCustomerPortalLink()) {
                $scope.customerPortalLink = '/account';
            }
        }
    };
});
